import React from "react";

import { generateClassString } from "../../lib/helper/generateClassString";

import * as styles from "./withGrid.module.less";

function withGrid(WrappedComponent) {
    const componentWithGrid = ({
        gridSize = "m",
        gridDisable = false,
        gridWrapperClass,
        ...props
    }) => (
        <div
            className={generateClassString(
                styles.imageContainer,
                styles.grid,
                styles[`grid${gridSize.toUpperCase()}`],
                [gridDisable, styles.hidden],
                gridWrapperClass,
                "grid"
            )}
        >
            <div className={styles.innerContainer}>
                <WrappedComponent {...props} />
            </div>
        </div>
    );

    return componentWithGrid;
}

export { withGrid };
